<template>
  <div class="game">
    <!-- 队长 -->
    <div
      class="captain"
      v-if="type == 1"
    >
      <div
        class="close"
        @click="hideGame()"
      >
        <img src="@/assets/close.png" />
      </div>
      <h1>请填写参与信息</h1>
      <div class="binding">
        <p>请选择游戏进行绑定</p>
        <i class="sao"></i>
        <select v-model="selected">
          <option
            v-for="(item, i) in game"
            :key="i"
            v-bind:value="item.papp_id"
          >
            {{ item.papp_name }}
          </option>
        </select>
      </div>
      <div>
        <div class="tips">注：信息一经提交无法修改，请确认好再提交哦~</div>
        <div
          class="btn"
          :class="!selected ? 'disabled' : ''"
          @click="confirm()"
        >提交信息</div>
      </div>
    </div>
    <!-- 队员 -->
    <div
      class="teammates"
      v-if="type == 0"
    >
      <div
        class="close"
        @click="hideGame()"
      >
        <img src="@/assets/close.png" />
      </div>
      <h1>请填写参与信息</h1>
      <div class="binding">
        <p>请选择游戏进行绑定</p>
        <span>{{ groupInfo.papp_name }}</span>
      </div>
      <div>
        <div class="tips">注：每人仅可加入一个队伍，请确认好再提交哦~~</div>
        <div
          class="btn"
          @click="personConfirm()"
        >提交信息</div>
      </div>
    </div>
  </div>
</template>
      
<script>
export default {
  name: "game",
  props: ["game", "type", "groupInfo"],
  data: function () {
    return {
      selected: "",
    };
  },
  methods: {
    hideGame() {
      this.$emit("hideGmae", true);
    },
    confirm() {
      if (this.selected) {
        this.$emit("confirm", this.selected);
      } else {
        this.$toast("请先选择游戏");
      }
    },
    personConfirm() {
      this.$emit("confirm", true);
    },
  },
  mounted() {
    console.log("type===", this.type);
  },
};
</script>
      
<style scoped lang="scss" src="@/sass/game.scss">
</style>